import { signal } from '@angular/core';
import { LeadStatusEnum } from '@partners/constants';
import { TCatalogOption } from '../model';

export const leadStatusCatalog$$ = signal<TCatalogOption[]>([
  { key: 'תחזרו אליי', value: LeadStatusEnum.interested },
  { key: 'לא כרגע', value: LeadStatusEnum.notInterested }
]);
